import envConfig from './env';
// 应用配置
export const config = {
    // API基础URL - 开发环境下自动通过代理转发到后端
    apiBaseUrl: '/api/v1',
    // 静态资源基础URL - 优先使用环境变量配置
    // 开发环境下优先走 devServer 代理（/uploads → 后端域名），因此默认留空使用相对路径
    staticBaseUrl: envConfig.assetBase || '',
    // 文件上传大小限制（MB）
    maxFileSize: 2,
    // 上传与压缩参数（前端控制，避免硬编码）
    upload: {
        // 目标最大体积（MB）
        maxSizeMB: 2,
        // 首次尝试压缩的JPEG质量
        jpegQuality: 0.84,
        // 最低允许的JPEG质量（二分逼近下限）
        minJpegQuality: 0.6,
        // 维度上限（超过则先按比例缩放）
        maxWidth: 1920,
        maxHeight: 1920,
        // 维度下限（避免极端缩至过小仍不达标的情况）
        minWidth: 320,
        minHeight: 320,
        // PNG压缩策略：仅按维度等比缩放，不转码
        pngScaleOnly: true
    }
};
export const BASE_URL = config.staticBaseUrl;
// 订单状态与支付状态中文映射（配置级，避免业务层硬编码）
export const ORDER_STATUS_LABEL = {
    PENDING_PAYMENT: '待付款',
    PENDING_SHIPMENT: '待发货',
    SHIPPED: '已发货',
    COMPLETED: '已完成',
    CANCELLED: '已取消',
    REFUNDED: '已退款',
    PARTIAL_REFUND: '部分退款'
};
export const PAY_STATUS_LABEL = {
    UNPAID: '未支付',
    PAID: '已支付',
    REFUNDING: '退款中',
    REFUNDED: '已退款'
};
export default config;
